import React from 'react';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import p1 from "../img/P3.png";
import p2 from "../img/P7.png";
import p3 from "../img/P2.png";
import p4 from "../img/P5.png";
import p5 from "../img/P8.png";
import u1 from "../img/U1.png";

export default function AllProject() {
  return (
    <div>
      <h2 className="text-4xl sm:text-4xl font-bold text-center pt-20 px-20">
        Projects
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-8">
        {[
          { img: p1, link: "/Pro1" },
          { img: p2, link: "/Pro3" },
          { img: p3, link: "/Pro5" },
          { img: p4, link: "/Pro2" },
          { img: p5, link: "/Pro4" },
          { img: u1, link: "/Pro6" },
        ].map((project, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05 }}
            className="bg-white shadow-lg rounded-lg overflow-hidden"
          >
            <Link to={project.link}>
              <img
                src={project.img}
                alt={`Project ${index}`}
                className="w-full h-auto"
              />
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
